module.exports = __webpack_public_path__ + "3a2496d964e13530db280987d9a1d23f.svg";